module.exports = __webpack_public_path__ + "img/微信通知.261e924c.png";